<template>
  <div id='Konstruktor'>
    <input
      class="scenarioId"
      v-model="scenario.id"
      type="hidden"
    />
    <input
      class="clientId"
      v-model="scenario.id"
      type="hidden"
    />
    <!--    <div class="horizontal_scroll_wrapper">-->
    <!--      <div class="horizontal_scroll_div"></div>-->
    <!--    </div>-->
    <div
      class='jtk-demo-main'
      id='jtk-demo-flowchart'
    >
      <div style='display:flex'>
        <div
          id='canvas'
          class='jtk-demo-canvas canvas-wide flowchart-demo jtk-surface jtk-surface-nopan'
        >
          <jsplumb-toolkit
            ref='toolkitComponent'
            v-bind:view='view'
            :scenarioId.sync="scenario.id"
            v-bind:client="name"
            :available-sms-gateways.sync="availableSmsGateways"
          ></jsplumb-toolkit>
        </div>
      </div>
    </div>
    <div class="zoomShell">
      <zoom element-id="canvas"/>
    </div>
    <div class="scenarioBarShell">
      <tool-buttons
        :name="name"
        :scenario.sync="scenario"
        :campaign-id="campaignid"
        @set="setScenario"
        @setDefault="setScenario"
        @initScenario="initScenarioFromCanvas"
      />
    </div>

    <div class="scenarioCommonParametersViewShell">
      <ScenarioCommonParams
        :hide-arrows="scenario.parameters.visual.hideArrows"
        :scenario-name="scenario.name"
        :locale="scenario.parameters.common.locale"
        :recognition-driver="scenario.parameters.common.recognitionDriver"
        @hideArrowsChange="hideArrowsChange"
        @scenarioNameChange="scenarioNameChange"
        @localeChange="localeChange"
        @recognitionDriverChange="recognitionDriverChange"
      />
    </div>
    <!--    <div class="scenarioInfoShell">-->
    <!--      <scenario-info-->
    <!--        :campaign-id="campaignid"-->
    <!--        :scenario-id="scenario.id"-->
    <!--      />-->
    <!--    </div>-->
  </div>
</template>

<script>
import BaseEditableNode from './BaseEditableNode.vue'
import Redirect from './Redirect'
import Sms from './Sms'
import ScenarioInfo from './ScenarioInfo'
import Zoom from './Zoom'
import ToolButtons from './ToolButtons'
import ScenarioCommonParams from './ScenarioCommonParams'
import HttpRequest from './HttpRequest'

export default {
  name: 'Konstruktor',
  props: ['name', 'campaignid', 'availableSmsGateways', 'pScenario'],
  components: {ScenarioCommonParams, ToolButtons, Zoom, ScenarioInfo},
  data() {
    return {
      view: {
        nodeComponent: BaseEditableNode,
        nodeRedirectComponent: Redirect,
        nodeSmsComponent: Sms,
        nodeHttpRequestComponent: HttpRequest
      },
      scenario: {
        id: '',
        template: 'universal',
        client: '',
        parameters: {
          states: [
            {
              data: {
                audio: [],
                id: '',
                title: this.$i18n.messages[this.$i18n.locale].scenarios.konstruktor.canvas.answer.startOfTalk,
                stateQuestion: this.$i18n.messages[this.$i18n.locale].scenarios.konstruktor.canvas.answer.startOfTalk,
                // titleTrans: 'scenarios.konstruktor.canvas.answer.startOfTalk',
                words: [],
                isSilence: false,  // Молчание
                isIllegibly: false, // Не разборчиво
                generationAudioType: 'generateFromText',
                searchStrategy: '',
                simulatedDelayMillis: 0,
                emotion: '',
                vendor: '',
                lang: '',
                speaker: '',
                speed: '',
                googleSsmlType: ''
              },
              view: {
                // w: 780,
                // h: 277,
                top: 20,
                left: 400, // ToDo
                baseHeight: 277,
                windowType: 'big'
              },
              startNode: true
            }
          ],
          connections: [],
          visual: {
            connector: 'Straight',
            hideArrows: false
          },
          common: {
            locale: 'ru-RU',
            recognitionDriver: 'google'
          }
        },
        checkDuration: true
      }
    }
  },
  methods: {
    setScenario(value) {
      this.initScenario(value)
      this.reDrawScenario()
    },
    initScenario(value) {
      if (value) {
        if (!value.parameters.visual) {
          value.parameters.visual = {
            connector: 'Straight',
            hideArrows: false,
            compactWindows: false
          }
        }
        if (!value.parameters.common) {
          value.parameters.common = {
            locale: 'ru-RU',
            recognitionDriver: 'google'
          }
        }
        if (!value.parameters.common.recognitionDriver) {
          value.parameters.common.recognitionDriver = 'google'
        }
        this.scenario = value
        let scenarioObj = document.querySelector('.active_scenario_universal')
        if (scenarioObj) {
          if (this.scenario.id) {
            scenarioObj.classList.add('is-saved')
          } else {
            scenarioObj.classList.remove('is-saved')
          }
        }
      }
    },
    reDrawScenario() {
      this.$children[0].drawScenario(this.scenario.parameters)
    },
    getNodeAudio(node) {
      let audio = []
      let audioItems = node.querySelectorAll('.audio_list .audio.audio_item')
      for (let i = 0; i < audioItems.length; i++) {
        let audioItem = audioItems[i]
        let audioObj = audioItem.querySelector('audio source')
        let audioParamObj = audioItem.querySelector('.audioParam')
        if (audioObj) {
          audio.push({
            type: 'url',
            id: audioItem.querySelector('.id').value,
            url: audioObj.getAttribute('src'),
            number: audioItem.querySelector('.number').value,
            duration: audioItem.querySelector('.audioDuration').value
          })
        } else if (audioParamObj) {
          audio.push({
            type: 'param',
            paramName: audioParamObj.value,
            vendor: node.parentElement.parentElement.querySelector('select.vendor').value,
            voice: node.parentElement.parentElement.querySelector('.speaker .voice').value,
            number: audioItem.querySelector('.number').value
          })
        }
      }
      audio.sort((a, b) => (a.number > b.number) ? 1 : -1)
      return audio
    },
    getNodeWords(node) {
      let words = []
      let tagsStr = (node.querySelector('.wordsEditor .tags-input.tags').textContent || '').split('\n')
      for (let i = 0; i < tagsStr.length; i++) {
        let tagStr = tagsStr[i].trim()
        if (tagStr && tagsStr.length) {
          words.push(tagStr)
        }
      }
      return words
    },
    initAnswersFromCanvas(toolkit) {
      let states = []
      let nodes = document.querySelectorAll('#Konstruktor .flowchart-object.answer_shell')
      for (let i = 0; i < nodes.length; i++) {
        let node = nodes[i]
        let view = {
          // w: node.offsetWidth,
          // h: node.offsetHeight,
          top: node.offsetTop,
          left: node.offsetLeft
        }
        if (node.classList.contains('medium')) {
          view.windowType = 'medium'
        } else if (node.classList.contains('small')) {
          view.windowType = 'small'
        }
        let state = {
          text: node.querySelector('.main .text').value,
          audio: this.getNodeAudio(node.querySelector('.mainAudioList')),
          generationAudioType: node.querySelector('.tab-content.is-active .generationType').value,
          id: node.id,
          title: node.querySelector('.answerTitle').innerText,
          stateQuestion: node.querySelector('input.stateQuestion').value,
          stateValue: node.querySelector('input.stateValue').value,
          useTranscribeByValue: !node.querySelector('.value .switch input').checked,
          words: this.getNodeWords(node),
          isSilence: node.querySelector('input.checkbox.isSilence').checked,
          isIllegibly: node.querySelector('input.checkbox.isIllegibly').checked,
          simulatedDelayMillis: node.querySelector('.simulatedDelayMillis').value,
          vendor: node.querySelector('.main .generate_audio_control select.vendor') ? node.querySelector('.main .generate_audio_control select.vendor').value : '',
          lang: node.querySelector('.main .generate_audio_control .lang') ? node.querySelector('.main .generate_audio_control .lang').value : '',
          speaker: node.querySelector('.main .generate_audio_control .voice') ? node.querySelector('.main .generate_audio_control .voice').value : '',
          emotion: node.querySelector('.main .generate_audio_control .emotion') ? node.querySelector('.main .generate_audio_control .emotion').value : '',
          speed: node.querySelector('.main .speed.generate_audio_control input') ? node.querySelector('.main .speed.generate_audio_control input').value : '',
          googleSsmlType: node.querySelector('.main .ssmlType') ? node.querySelector('.main .ssmlType').value : ''
        }
        let searchStrategyObj = node.querySelector('.searchStrategy')
        let searchStrategyTrObj = searchStrategyObj.closest('tr')
        if (searchStrategyObj && searchStrategyObj.style.display !== 'none' && searchStrategyTrObj && searchStrategyTrObj.style.display !== 'none') {
          state.searchStrategy = searchStrategyObj.value
        }

        state.recognitionDriver = node.querySelector('.playSourceConfig .recognitionDriver').value
        state.timeout = node.querySelector('.playSourceConfig .timeout').value
        state.startCollectBeforePlayEnd = node.querySelector('.playSourceConfig .startCollectBeforePlayEnd').value
        state.waitingInputTimeout = node.querySelector('.playSourceConfig .waitingInputTimeout').value
        state.silenceAfterSpeechTimeout = node.querySelector('.playSourceConfig .silenceAfterSpeechTimeout').value
        state.delayBeforeCollect = node.querySelector('.playSourceConfig .delayBeforeCollect').value

        let fullState = {data: state, view: view, startNode: !!node.classList.contains('start-node')}
        let redirectData = toolkit.getRedirectData(node.id)
        if (redirectData) {
          fullState.redirectSipNumber = redirectData.sip
          fullState.redirectView = redirectData
        }
        fullState.smsData = toolkit.getSmsData(node.id)
        fullState.httpRequestData = toolkit.getHttpRequestData(node.id)

        states.push(fullState)
      }
      return states
    },
    initInOutStatesFromCanvas() {
      let states = []
      let nodes = document.querySelectorAll('#Konstruktor .flowchart-object.inOutState_shell')
      for (let i = 0; i < nodes.length; i++) {
        let node = nodes[i]
        let view = {
          top: node.offsetTop,
          left: node.offsetLeft
        }
        let isSilence = node.querySelector('input.checkbox.isSilence').checked
        let isIllegibly = node.querySelector('input.checkbox.isIllegibly').checked
        let recognitionDriver = ''
        let driverObj = node.querySelector('.driver select')
        if (driverObj) {
          recognitionDriver = driverObj.value
        }
        let state = {
          id: node.id,
          title: node.querySelector('.answerTitle').value,
          // stateQuestion: node.querySelector('input.stateQuestion').value,
          // stateValue: node.querySelector('input.stateValue').value,
          words: (!isSilence && !isIllegibly) ? this.getNodeWords(node) : [],
          isSilence: isSilence,
          isIllegibly: isIllegibly,
          recognitionDriver: recognitionDriver
        }

        let fullState = {data: state, view: view, type: 'inOutState'}
        states.push(fullState)
      }
      return states
    },
    initOutStatesFromCanvas() {
      let states = []
      let nodes = document.querySelectorAll('#Konstruktor .flowchart-object.outState_shell')
      for (let i = 0; i < nodes.length; i++) {
        let node = nodes[i]
        let view = {
          top: node.offsetTop,
          left: node.offsetLeft
        }
        let state = {
          id: node.id,
          title: node.querySelector('.answerTitle').value
        }

        let fullState = {data: state, view: view, type: 'outState'}
        states.push(fullState)
      }
      return states
    },
    initScenarioFromCanvas() {
      console.log('initScenarioFromCanvas')
      let toolkit = this.$children[0]
      let parameters = {
        states: [],
        connections: []
      }
      let answers = this.initAnswersFromCanvas(toolkit)
      let inOutStates = this.initInOutStatesFromCanvas()
      let outStates = this.initOutStatesFromCanvas()

      for (let i = 0; i < answers.length; i++) {
        parameters.states.push(answers[i])
      }
      for (let i = 0; i < inOutStates.length; i++) {
        parameters.states.push(inOutStates[i])
      }
      for (let i = 0; i < outStates.length; i++) {
        parameters.states.push(outStates[i])
      }

      let connections = toolkit.getAllConnections()
      if (connections) {
        for (let i = 0; i < connections.length; i++) {
          let connection = {
            sourceId: connections[i].sourceId,
            targetId: connections[i].targetId
          }
          parameters.connections.push(connection)
        }
      }
      let common = this.scenario.parameters.common
      let visual = this.scenario.parameters.visual
      let parametersDefaultValues = this.scenario.parameters.parametersDefaultValues
      this.scenario.parameters = parameters
      this.scenario.parameters.visual = visual
      this.scenario.parameters.common = common
      this.scenario.parameters.parametersDefaultValues = parametersDefaultValues
    },

    hideArrowsChange(hideArrowsChange) {
      if (this.scenario) {
        this.scenario.parameters.visual = this.scenario.parameters.visual || {}
        this.scenario.parameters.visual.hideArrows = hideArrowsChange
        if (hideArrowsChange) {
          document.getElementById('canvas').classList.add('hidden_arrows')
        } else {
          document.getElementById('canvas').classList.remove('hidden_arrows')
        }
      }
    },
    scenarioNameChange(name) {
      this.scenario.name = name
    },
    localeChange(locale) {
      this.scenario.parameters.common = this.scenario.parameters.common || {}
      this.scenario.parameters.common.locale = locale
    },
    recognitionDriverChange(driver) {
      this.scenario.parameters.common = this.scenario.parameters.common || {}
      this.scenario.parameters.common.recognitionDriver = driver
    }
  },
  created() {
    window.addEventListener('scroll', function (event) {
      let konstruktor = document.getElementById('Konstruktor')
      if (konstruktor) {
        if (this.scrollY > 16) {
          konstruktor.classList.add('scrolled')
        } else {
          konstruktor.classList.remove('scrolled')
        }
      }
    })
    this.initScenario(this._props.pScenario)
  },
  mounted() {
    this.reDrawScenario()
  }
}
</script>

<style scoped>
@import "../../../../node_modules/bulma/css/bulma.css";
@import "../../../../node_modules/font-awesome/css/font-awesome.css";
/*@import "../../../../node_modules/bulma/sass/utilities/mixins.sass";*/
@import "css/constructor.css";
@import "css/canva.css";
@import "css/flowchart_object.css";

/*#Konstruktor {*/
/*  margin-top:-70px;*/
/*}*/

/*#Konstruktor {*/
/*  overflow-x: scroll;*/
/*}*/
/*.horizontal_scroll_wrapper{*/
/*  height: 20px;*/
/*  overflow-x: scroll;*/
/*  overflow-y:hidden;*/
/*}*/
/*.horizontal_scroll_div {*/
/*  width:3600px;*/
/*  height: 20px;*/
/*}*/

#Konstruktor .scenarioCommonParametersViewShell {
  position: fixed;
  float: left;
  bottom: 0;
  left: 8px;
  z-index: 100000;
  max-width: 132px;
  background-color: white;
}
</style>

<style>
#Konstruktor .answer .generation_radios {
  display: none;
}

#Konstruktor .generation_radios {
  display: none;
}

#Konstruktor input[type="range"].slider.is-small {
  width: 110px;
}

#Konstruktor .generate_audio_control {
  margin-top: 10px;
  margin-bottom: 0;
}

#Konstruktor .generate_audio_control.speed {
  margin-top: 13px;
}

#Konstruktor .player {
  width: 100%;
}

/*#Konstruktor .player .player-progress {*/
/*  width: 256px;*/
/*}*/
#Konstruktor .size_1 .audio_list .audio .player .player-progress {
  width: 700px;
}

#Konstruktor .size_2 .audio_list .audio .player .player-progress {
  width: 300px;
}

#Konstruktor .medium .size_2 .audio_list .audio .player .player-progress {
  width: 121px;
}

#Konstruktor
.answer_shell.medium
.size_1
.audio_list
.audio
.player
.player-progress {
  width: 320px;
}

#Konstruktor .answer_shell.medium .size_1 .audio_list .audio .player .volume {
  display: none;
}

#Konstruktor .answer_shell.medium .size_2 .audio_list .audio .player .volume {
  display: none;
}

#Konstruktor
.answer_shell.medium
.size_more_2
.audio_list
.audio
.player
.volume {
  display: none;
}

#Konstruktor
.start-node.answer_shell.medium
.audio_list
.audio
.player
.volume {
  display: none;
}

#Konstruktor .answer_shell .audio_list .audio .player .volume {
  display: none;
}

#Konstruktor .answer_shell .audio_list .audio .player .muting {
  display: none;
}

/*#Konstruktor .size_2 .audio_list .audio .player .player-progress {*/
/*  width: 64px;*/
/*}*/
#Konstruktor
.answer_shell.medium
.size_2
.audio_list
.audio
.player
.player-progress {
  width: 121px;
}

.tabs-content .tab-content.uploadFile .uploadFromFileDiv[data-v-879764ec] {
  text-align: center;
  /* vertical-align: middle; */
  padding-top: 13px;
}

#Konstruktor .answer_shell.small .audio_list .audio,
#Konstruktor .answer_shell.small .size_more_2 .audio_list .audio {
  display: block;
  max-width: 100%;
}

#Konstruktor .small .audio_list .audio .player .player-progress {
  width: 140px !important;
}

#Konstruktor .answer_shell.small .audio_list .audio .player .volume {
  display: none !important;
}

#Konstruktor .answer_shell.small .audio_list .audio .player .muting {
  display: none !important;
}

#Konstruktor .answer_shell.small .audio_list .audio .player .download {
  display: none !important;
}

#Konstruktor .answer_shell .repeatAudioList .player .player-progress {
  background-color: #b26a59;
}

#Konstruktor .answer_shell .repeatFailAudioList .player .player-progress {
  background-color: #b23524;
}

/*#Konstruktor .size_2.audio_list .audio .volume {*/
/*  width: 50px;*/
/*}*/
#Konstruktor .size_1 .audio_list .audio .volume input {
  width: 120px;
}

#Konstruktor .size_2 .audio_list .audio .volume input {
  width: 60px;
}

.active_scenario_universal .tile {
  padding: 0;
}

.active_scenario_universal .choose_scenario {
  z-index: 10;
  position: absolute;
}

/*.active_scenario_universal {*/
/*  overflow-x: scroll;*/
/*  overflow-y: hidden;*/
/*}*/

#Konstruktor #canvas {
  height: 8000px;
  width: 4096px;
  transform-origin: top left;
}

#Konstruktor .flowchart-demo .jtk-connector {
  z-index: 22;
}

#Konstruktor .scenarioBarShell {
  position: fixed;
  top: 66px;
  right: 20px;
  z-index: 1000;
  max-height: 73px;
  min-width: 160px;
  background-color: white;
  /*width: 100%;*/
}

#Konstruktor.scrolled .scenarioBarShell {
  top: 7px;
  /*right: 460px;*/
  z-index: 10000;
  max-height: 32px;
  background: transparent;

  right: unset;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;

  text-align: center;
  width: 92%;
}

#Konstruktor.scrolled .zoomShell {
  top: 7px;
  left: 316px;
  z-index: 10000;
  max-height: 32px;
}

#Konstruktor.scrolled .zoomShell p {
  display: inline-block;
  margin-bottom: 0;
  margin-right: 8px;
}

#Konstruktor .zoomShell {
  position: fixed;
  /*top: 115px;*/
  /*left: 20px;*/
  left: 169px;
  z-index: 50;
  /*width: 128px;*/
  background-color: white;
}

#Konstruktor .scenarioInfoShell {
  position: fixed;
  top: 160px;
  right: 20px;
}

#Konstruktor .answer_shell .vue-bulma-tabs .tab-content {
  margin: 0;
}

#Konstruktor .answer_shell .vue-bulma-tabs .tabs {
  margin: 0;
}

#Konstruktor .allAudios .player .player-progress {
  width: 300px;
}

#Konstruktor .allAudios .player .volume input {
  width: 64px;
}

/*#Konstruktor .jtk-endpoint {*/
/*  display:none;*/
/*}*/

.active_scenario_universal.is-saved .choose_scenario {
  display: none;
}

.active_scenario_universal.is-saved #Konstruktor .zoomShell {
  top: 115px;
}

.active_scenario_universal #Konstruktor .zoomShell {
  top: 175px;
}

.active_scenario_universal #Konstruktor.scrolled .zoomShell {
  top: 7px;
}

html {
  overflow-x: scroll;
  overflow-y: scroll;
}

#Konstruktor #canvas.hidden_arrows .jtk-connector {
  display: none;
}

#Konstruktor
.inOutState_shell
.wordsEditor
.collapse
.collapse-item
.card-content {
  padding: 0;
  margin-top: -38px;
}

#Konstruktor .inOutState_shell .wordsEditor .tags-input-text {
  width: 90%;
}

/*#Konstruktor .answer_shell .wordsEditor .tags-input-text {*/
/*  width:90%;*/
/*}*/

#Konstruktor
.inOutState_shell
.wordsEditor
.collapse
.collapse-item
.card-content
.card-content-box {
  padding: 0;
}

#Konstruktor
.inOutState_shell
.wordsEditor
.collapse
.collapse-item
.card-content
.card-content-box
.tags-input
div.control {
  width: 90%;
}

#Konstruktor
.inOutState_shell
.wordsEditor
.collapse
.collapse-item
.card-header {
  box-shadow: unset;
}

.loggedRole-32 #Konstruktor .answer_shell .hidden_for_client_automation {
  display: none;
}

.loggedRole-32 #Konstruktor .answer_shell .hidden_for_client,
.loggedRole-16 #Konstruktor .answer_shell .hidden_for_client {
  display: none;
}

.loggedRole-1 #Konstruktor .overlay-for-not-admin,
.loggedRole-2 #Konstruktor .overlay-for-not-admin {
  display: none;
}

#Konstruktor .ConnectionsToTargetsSize-0 .addHttpRequest {
  display: inline-block;
}

#Konstruktor .ConnectionsToTargetsSize-0 .searchStrategyTr,
.ConnectionsToTargetsSize-1 .searchStrategyTr {
  display: none;
}

#Konstruktor .suggestionDiv input {
  border-radius: unset;
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// ScenarioKonstruktor.vue?47e36c1a